import {
    ACTIVE, ADTA_ASSET_TYPE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET,
    ALERT_UPDATE_SUCCESS_ASSET_MESSAGE, DEFAULT_VENDOR_ATTRIBUTES,
    DEPRECATED, FALSE_VALUE, getUpdateAssetMessageAlertWithSite,
    LOADING_FAILED, LOADING_STRING
} from "../../../util/Constants";
import {
    chainWalk,
    checkInactiveOrDeprecatedAsset,
    compressSorterConfig,
    convertTableJsonToAsset,
    deepCopyObject,
    getAssetLabelFromMac,
    getNodeId,
    logOperationalMetric,
    getAliasFromParent, setAliasToRequest, isResponseCode5xx
} from "../../../util/Util";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset, updateAssetInPlace
} from "../../../resources/AssetResource";
import {
    updateConfigurationsInAdtaAssetObject
} from "../datamodel/AdtaAssetModelResource";
import {getAdtaDeviceStatus} from "../../../resources/StatusResource";

const metricProcessName = "ADTA_DEVICE_DETAILS";

export function fetchAdtaDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: ADTA_ASSET_TYPE
    }
    getAdtaDeviceDetails(dispatcher, request)
}

export function fetchAdtaStatusDetails(dispatcher, model) {
    getAdtaDeviceStatusDetails(dispatcher, model)
}

export function deleteAdtaDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedAdtaDeviceDetails(dispatcher, request)
}

export function setAdtaDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, ADTA_ASSET_TYPE, ACTIVE);
    addAdtaDeviceDetails(dispatcher, request, showCustomAlert)
}

export function updateAdtaDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    const request = convertTableJsonToAsset(stateValues, ADTA_ASSET_TYPE, ACTIVE);
    updateAdtaAsset(dispatcher, request, showCustomAlert);
}

export async function updateAdtaDeviceMac(dispatcher, stateValues, mac, showCustomAlert) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        showCustomAlert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", false, false);
    } else {
        deleteAdtaDeviceDetails(dispatcher, mac);
        setAdtaDeviceDetails(dispatcher, stateValues, showCustomAlert);
    }
}

async function getAdtaDeviceDetails(dispatcher, request) {
    const model = {
        adtaDeviceInformation: {},
        sorterConfig: {},
        sorterTestPackageConfig: {},
        macAddressArray: []
    }

    // Fetch static asset details
    await getADTADeviceStaticDetails(dispatcher, model, request);
    // Fetch asset status details
    await getAdtaDeviceStatusDetails(dispatcher, model)
}

const addADTADeviceStaticDetailsToModel = (result, model) => {
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((adtaDeviceDetail) => {
            if (adtaDeviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(adtaDeviceDetail.assetAttributes.mac)
                const mac = adtaDeviceDetail.assetAttributes.mac;
                const id = JSON.parse(adtaDeviceDetail.assetAttributes.deviceConfig).id;
                model.adtaDeviceInformation[mac] = {
                    name: adtaDeviceDetail.assetAttributes.name,
                    mac: adtaDeviceDetail.assetAttributes.mac,
                    ip: adtaDeviceDetail.assetAttributes.ip,
                    id: id,
                    port: adtaDeviceDetail.assetAttributes.port,
                    vendorAttributes: getVendorAttributes(adtaDeviceDetail.vendorAttributes),
                    assetStatus: LOADING_STRING,
                    deviceType: adtaDeviceDetail.assetAttributes.deviceType,
                    assetType: adtaDeviceDetail.assetType,
                    maxRecircPerPackage: chainWalk(() => parseInt(adtaDeviceDetail.assetAttributes.maxRecircPerPackage, 10), 0),
                    startTime: chainWalk(() => JSON.parse(adtaDeviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(adtaDeviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(adtaDeviceDetail.assetAttributes.monitoring).reason, ""),
                }
                model.sorterTestPackageConfig[mac] = chainWalk(() =>
                    JSON.parse(adtaDeviceDetail.assetAttributes.sorterTestPackage, []));
                const sorterConfig = chainWalk(() =>
                    JSON.parse(adtaDeviceDetail.assetAttributes.sorterConfig), []);
                model.sorterConfig[mac] = compressSorterConfig(sorterConfig);
            }
        });
    }
    return model;
}

const getVendorAttributes = (vendorAttributes) => {
    const vendor = vendorAttributes.vendor || DEFAULT_VENDOR_ATTRIBUTES.vendor;
    const spec_version = vendorAttributes.spec_version || DEFAULT_VENDOR_ATTRIBUTES.spec_version;
    const sorter_type = vendorAttributes.sorter_type || DEFAULT_VENDOR_ATTRIBUTES.sorter_type;
    const hamper_vendor = vendorAttributes.hamper_vendor || DEFAULT_VENDOR_ATTRIBUTES.hamper_vendor;
    const hamper_version = vendorAttributes.hamper_version || DEFAULT_VENDOR_ATTRIBUTES.hamper_version;
    const incoming_auto_singulated = vendorAttributes.incoming_auto_singulated || FALSE_VALUE;
    const incoming_auto_sorted = vendorAttributes.incoming_auto_sorted || FALSE_VALUE;

    return {
        vendor,
        spec_version,
        sorter_type,
        hamper_vendor,
        hamper_version,
        incoming_auto_singulated,
        incoming_auto_sorted
    };
}

async function getAdtaDeviceStatusDetails(dispatcher, model) {
    // Fetch Adta device statuses
    const startTime = Date.now();
    const adtaStatusResponse = await getAdtaDeviceStatus(model.macAddressArray);
    const isSuccess = adtaStatusResponse.status === 200;
    const isFault = isResponseCode5xx(adtaStatusResponse.status)
    // Merge status to model and return
    if (isSuccess) {
        mergeStatusToModel(adtaStatusResponse, model)
    } else {
        model.macAddressArray.forEach((mac) => {
            model.adtaDeviceInformation[mac].assetStatus = LOADING_FAILED
        })
    }
    dispatcher({type: "RECEIVE_DATA", data: model});

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceStatusDetails", isSuccess, isFault);
}

async function getADTADeviceStaticDetails(dispatcher, model, request) {
    let pageToken = null;

    // do-while loop until we get a valid pageToken
    do {
        const startTime = Date.now();
        const getAssetsResult = await getAssets(request.nodeId, request.assetType, pageToken)
        const isSuccess = getAssetsResult.status === 200;
        const isFault = isResponseCode5xx(getAssetsResult.status)

        // Log operation
        logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceDetails", isSuccess, isFault);

        if (isSuccess) {
            addADTADeviceStaticDetailsToModel(getAssetsResult, model)
            // modifying pageToken to fetch from the latest get assets' result
            pageToken = getAssetsResult.data.pageToken
        } else {
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    } while (pageToken);
}

async function setAssetLabelDeprecatedAdtaDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAdtaDeviceDetails", true, false);
            fetchAdtaDeviceDetails(dispatcher);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteAdtaDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function updateAdtaConfiguration(dispatcher, configurations, mac, showCustomAlert) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const alias = await getAliasFromParent();
    const updatedAsset = updateConfigurationsInAdtaAssetObject(getAssetResult.data.asset, configurations, alias);
    const updateResult = await updateAsset(updatedAsset, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isUpdateSuccess = updateResult.status === 200;
    const isFault = isResponseCode5xx(updateResult.status)
    fetchAdtaDeviceDetails(dispatcher)

    // Log operation
    isUpdateSuccess ? showCustomAlert(ALERT_UPDATE_SUCCESS_ASSET_MESSAGE) : showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
    logOperationalMetric(startTime, metricProcessName, "updateAdtaConfiguration", isUpdateSuccess, isFault);
}

async function addAdtaDeviceDetails(dispatcher, request, showCustomAlert) {
    const startTime = Date.now();
    await setAliasToRequest(request);
    addAsset(request).then(async result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const isFault = isResponseCode5xx(result.status)
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdateAsset = isResponseCode5xx(responseUpdateAsset.status)
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", false, isFaultInUpdateAsset);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", true, false);
        }
        fetchAdtaDeviceDetails(dispatcher)
    });
}

async function updateAdtaAsset(dispatcher, request, showCustomAlert) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAdtaDeviceDetails(dispatcher);
        return;
    }
    // Update asset details
    const startTime = Date.now();
    await setAliasToRequest(request);
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isSuccess = updateAssetResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAdtaDeviceDetails", isSuccess, isFault);
    fetchAdtaDeviceDetails(dispatcher);
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "adtaStatusList" in response.data) {
        response.data.adtaStatusList.forEach((singleAdtaDeviceStatusDetail) => {
            model.adtaDeviceInformation[singleAdtaDeviceStatusDetail.mac].assetStatus = singleAdtaDeviceStatusDetail.status
        })
    }
}

async function updateAdtaMonitoringSchedule(dispatcher, request) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request, chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAdtaDeviceDetails", isSuccess, isFault);
    fetchAdtaDeviceDetails(dispatcher);
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

export async function updateAdtaMonitoringDetails(dispatcher, stateValues, mac){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateAdtaMonitoringSchedule(dispatcher, updatedAsset)
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/network/AdtaDeviceOverviewNetworkAPI.js